import { copyToClipboard } from './copyToClipboard';

export const share = async ({ title = '', text = '', url, files }) => {
  if (!navigator.share) {
    copyToClipboard(url);
  } else {
    try {
      await navigator.share({
        title,
        text,
        url,
        files,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
};
